import { useToast } from '../../contexts/ToastContext'
import { cn } from '../../lib/cn'
import { useState } from 'react'
import { tryCopyText } from '../../lib/clipboard'

interface CopyButtonProps {
  /** Text to place on the clipboard. */
  value: string
  /** Noun for the toast: "{what} copied — paste it into the game." */
  what?: string
  children?: React.ReactNode
  className?: string
}

export function CopyButton({ value, what = 'It', children = 'Copy', className }: CopyButtonProps) {
  const { flash } = useToast()
  const [manual, setManual] = useState(false)

  async function copy() {
    if (await tryCopyText(value)) { setManual(false); flash(`${what} copied — paste it into the game.`) }
    else setManual(true)
  }

  return (
    <span className="inline-flex min-w-0 flex-col gap-2">
    <button
      type="button"
      onClick={copy}
      className={cn(
        'inline-flex items-center rounded-btn border border-line bg-paper-surface px-3 py-2 font-mono text-[11px] uppercase tracking-label text-ink-muted transition-colors hover:border-terra hover:text-terra-deep',
        className,
      )}
    >
      {children}
    </button>
    {manual && <span className="min-w-0 text-[12px] text-ink-muted"><span role="alert">Copy was blocked. Select and copy this text:</span><textarea aria-label={`${what} to copy`} readOnly value={value} onFocus={(event) => event.currentTarget.select()} className="mt-1 w-full min-w-0 rounded-input border border-line p-2 text-ink" /></span>}
    </span>
  )
}
